import React, { useState } from 'react';
import { Row, Col, Upload, Button as AntButton, Icon, message } from 'antd';
import { useHistory } from 'react-router-dom';

import * as Form from 'components/common/form';
import { Heading } from 'components/common/typography';

import { PurchaseAPI } from 'api';

import RoutesGenerator, { Route } from 'services/router/generator';

import BankDetails from '../bank-details';

import './styles.less';
import translate from 'i18n/translate';


const { Button } = Form;

interface SubmitSlipProps {
  bankDetails: any;
}

const SubmitSlip = (props: SubmitSlipProps) => {
  const history = useHistory();
  const { bankDetails } = props;
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [file, setFile] = useState<any>([]);

  const handleClick = async () => {
    try {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append('reference_number', bankDetails[0].installments.reference_number);
      formData.append('id', bankDetails[0].installments.id);
      formData.append('image', file[0].originFileObj);
      await PurchaseAPI.submitDepositSlip(formData);
      setIsSubmitting(false);
      message.success('Successfully submitted the deposit slip.');
      history.push(`${RoutesGenerator(Route.Dashboard)}?tab=2`);
    } catch (error) {
      setIsSubmitting(true);
      console.error(error);
    }
  };

  const uploadProps = {
    accept: 'image/*',
    beforeUpload() {
      return false;
    },
    onChange(info: any) {
      let fileList = [...info.fileList];
      fileList = fileList.slice(-1);
      setFile(fileList);
    },
  };

  return (
    <div className="complete-purchase">
      <Row gutter={24} type="flex">
        <Col md={24}>
          <Heading type={3}>{translate('bankPayment.submitSlip.title')}</Heading>
          <p>{translate('bankPayment.submitSlip.step1')}</p>
          <BankDetails bankDetails={bankDetails} />
          <p>{translate('bankPayment.submitSlip.step2')}</p>
          <p>{translate('bankPayment.submitSlip.notice')}</p>
        </Col>
        <Col md={8}>
          <div>
            <Upload {...uploadProps} fileList={file}>
              <AntButton>
                <Icon type="upload" />
                {translate('bankPayment.submitSlip.uploadBtn')}
              </AntButton>
            </Upload>
          </div>
        </Col>
        <Col md={24}>
          <Button size="large" className="next-btn" onClick={handleClick} loading={isSubmitting} disabled={file.length < 1}>
          {translate('bankPayment.submitSlip.submit')}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SubmitSlip;
